import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d7fb1026&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fb1026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7fb1026')) {
      api.createRecord('d7fb1026', component.options)
    } else {
      api.reload('d7fb1026', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d7fb1026&scoped=true", function () {
      api.rerender('d7fb1026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/groupBuy/index.vue"
export default component.exports